import React, { Component } from "react";
import Select from "react-select";
import { Button } from "zina-dogi-react";
import DropFiles from "./drop_files.component";
import { utils } from "../../../utils/utils";
import { service } from "../../../sode/oet/redux"
import { service as run_service } from "../../run/redux"
import ModalDefault from "./modal_default.component"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { SAPModalHistory } from "~/non-sode/oet";


export default class RunCreatorModal extends Component {
    constructor(props) {
        super(props);
        const hasItems = this.props.items && this.props.items.length > 0;
        this.state = {
            file: null,
            oet_bypassed: this.props.oet ?
                this.props.oet.bypassed : 'false',
            bypass_load: false,
            selected_item: null,
            cmn_message:
                hasItems && this.props.items[0].cmn_totals ?
                    this.props.items[0].cmn_totals.message : null
        };
        this.formRef = React.createRef()
        this.bypassRef = React.createRef()
    }

    toggle = (mod = { modal: !this.state.modal }) => {
        this.setState({
            selected_oet_item: null,
            file: null,
            ...mod
        });
    };

    load_file_after_drop = (file) => {
        this.setState({ file: file, errorMessage: [] });
    }

    select_change = (item) => {
        if (!item) {
            return
        }
        const item_id = item.value
        let message = null;
        const items = this.props.oet.items;
        for (let i = 0; i < items.length; i++) {
            if (items[i].id.toString() === item_id.toString()) {
                message = items[i].cmn_totals && items[i].cmn_totals.message ? items[i].cmn_totals.message : message;
                this.setState({ selected_oet_item: items[i] })
            }
        }
        if (message !== this.state.cmn_message) {
            this.setState({ cmn_message: message });
        }
    };

    onSuccess = (values, resetForm) => {
        const { onCreateRun } = this.props;
        const { file } = this.state;
        const item_id = values.oet_item.value;
        const type_flow = values.type_flow.value;
        onCreateRun({ item_id, type_flow, file });
        this.toggle();
    };

    bypassHandler = (values, resetForm) => {
        /**
        * This method handles the Bypass item button in modal
        */
        const item_id = values.oet_item.value;
        const body = {
            bypassed: true,
            oet_item: [item_id],
            bypass_quantity: values.bypass_quantity
        }
        utils.show_warning_message(
            this.props.bypassSubmit, [service.updateOrderEntryTemplateItem, [body]]
        )
        this.toggle({ bypass_modal: !this.state.bypass_modal });
    }

    render() {
        const { oet, user } = this.props;
        const has_bypass_perm = utils.user_has_perm(user, 'can_by_pass_oet')
        const type_flow_options = oet.type_flow_options.map((item, i) => {
            if (!item.cancelled) {
                return { value: item.value, label: item.label }
            }
            return null;
        })
        const { modal, bypass_modal } = this.state;
        const cpo_reg = oet.customer_purchase_order
        const oet_item_options = oet.items.map((item, i) => {
            if (!item.cancelled) {
                return {
                    value: item.id,
                    label: `Item #${item.item}${item.code ? ` -  ${item.code}` : ""}`
                }
            }
            return null;
        })
        return (
            <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <React.Fragment>
                        <span style={{ margin: "4px" }} />
                        {has_bypass_perm && utils.check_validation_type(cpo_reg) && (
                            <Button
                                style={{ marginLeft: "8px" }}
                                color="danger"
                                onClick={
                                    () => this.toggle({ bypass_modal: !this.state.bypass_modal })
                                }
                            >
                                {'Bypass OET'}
                            </Button>

                        )}
                        <Button
                            style={{ marginLeft: "8px" }}
                            color="success"
                            onClick={() => this.toggle()}
                            disabled={this.props.disabled}
                        >
                            Add New Run
                        </Button>
                        <span style={{ margin: "4px" }} />
                        <UncontrolledDropdown>
                            <DropdownToggle caret>
                                <i className='fas fa-cog'></i>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={()=> this.refs.history_modal.open()}>
                                    <span>Bypass history </span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </React.Fragment>
                </div>
                <SAPModalHistory
                    ref="history_modal"
                    cancelled={true}
                    onSubmit={() => run_service.getBypassHistory({oet: oet.id})}
                    runID={this.props.runID}
                    status={7}
                    headers={
                        [
                            "Item", 
                            "Bypassed by", "Bypassed qty", "Bypass date",
                            "User", 
                        ]
                    }
                    columns={
                        [
                            {
                                data: "oet_item.item",
                                editor: false,
                            },
                            {
                                data: "oet_item.bypassed_by.username",
                                editor: false,
                                className: "htMiddle htMiddle"
                            },
                            {
                                data: 'oet_item.bypass_quantity',
                                editor: false,
                                className: "htMiddle htMiddle"
                            },
                            {
                                data: 'oet_item.bypass_date',
                                editor: false,
                                className: "htMiddle htMiddle"
                            },
                        ]
                    }
                />
                {oet && <ModalDefault
                    oet={oet}
                    reference={this.bypassRef}
                    is_open={bypass_modal}
                    toggle={() => this.toggle({ bypass_modal: !this.state.bypass_modal })}
                    select_change={this.select_change}
                    button_success={'Bypass item'}
                    on_submit={this.bypassHandler}
                    header={'OET Item bypass'}
                    extra_fields={[
                        {
                            label: 'OET item',
                            validate_general: true,
                            extra_props: {
                                name: 'oet_item',
                                component: Select,
                                options: oet_item_options,
                                isClearable: true,
                                cacheOptions: true,
                                defaultOptions: true,
                                onChange: (val) => {
                                    this.bypassRef.current.setFieldValue("oet_item", val, false)
                                    this.select_change(val)
                                }
                            }
                        },
                        {
                            label: 'Bypass quantity',
                            validate_general: true,
                            extra_props: {
                                name: 'bypass_quantity', type: 'number'
                            }
                        }
                    ]}
                />
                }
                {oet && <ModalDefault
                    oet={oet}
                    reference={this.formRef}
                    is_open={modal}
                    toggle={() => this.toggle()}
                    select_change={this.select_change}
                    button_success={'Create Run'}
                    on_submit={this.onSuccess}
                    header={'Run creation'}
                    drop_component={
                        cpo_reg && <DropFiles
                            cpo_register={cpo_reg}
                            selected_oet_item={this.state.selected_oet_item}
                            load_file={this.load_file_after_drop}
                        />
                    }
                    extra_fields={[
                        {
                            label: 'OET item',
                            validate_general: true,
                            extra_props: {
                                name: 'oet_item',
                                component: Select,
                                options: oet_item_options,
                                isClearable: true,
                                cacheOptions: true,
                                defaultOptions: true,
                                onChange: (val) => {
                                    this.formRef.current.setFieldValue("oet_item", val, false)
                                    this.select_change(val)
                                }
                            }
                        },
                        {
                            label: 'Type',
                            validate_general: true,
                            extra_props: {
                                name: 'oet_item',
                                component: Select,
                                options: type_flow_options,
                                isClearable: true,
                                cacheOptions: true,
                                defaultOptions: true,
                                onChange: (val) => {
                                    this.formRef.current.setFieldValue("type_flow", val, false)
                                }
                            }
                        }
                    ]}
                />
                }
            </div>
        );
    }
}
